import { render } from "./ImageTab.vue?vue&type=template&id=b129b8de&scoped=true"
import script from "./ImageTab.vue?vue&type=script&lang=js"
export * from "./ImageTab.vue?vue&type=script&lang=js"

import "./ImageTab.vue?vue&type=style&index=0&id=b129b8de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b129b8de"]])

export default __exports__